import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=0e99d250&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&id=0e99d250&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e99d250')) {
      api.createRecord('0e99d250', component.options)
    } else {
      api.reload('0e99d250', component.options)
    }
    module.hot.accept("./personal.vue?vue&type=template&id=0e99d250&", function () {
      api.rerender('0e99d250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/personal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/personal.vue
// module id = /OIP
// module chunks = 0